import { useState } from 'react';

const NAV_ITEMS = [
  { label: '今日热榜', href: '#trending' },
  { label: '热门话题', href: '#topics' },
  { label: '观点对撞', href: '#comments' },
  { label: '讨论版块', href: '#channels' },
  { label: '常见问题', href: '#faq' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [hint, setHint] = useState('');

  const handleSearch = () => {
    if (!keyword.trim()) {
      setHint('输入一个话题关键词试试，比如「彩蛋」「时间线」');
      return;
    }
    setHint(`已为你定位到与「${keyword.trim()}」相关的讨论方向（演示效果）`);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-[1200px] items-center gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-base" />
          </span>
          <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950">黑料社网</h1>
        </a>

        <nav className="ml-4 hidden items-center gap-1 lg:flex">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-2 md:flex">
          <div className="flex h-9 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3">
            <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-sm" />
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleSearch();
              }}
              placeholder="搜索话题 / 关键词"
              className="w-40 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500 lg:w-48"
            />
            <button
              type="button"
              onClick={handleSearch}
              className="cursor-pointer whitespace-nowrap text-xs font-medium text-primary-700 hover:text-primary-800"
            >
              搜索
            </button>
          </div>
          <button
            type="button"
            onClick={() => setHint('加入入口为演示效果，正式版本会引导你完成注册后参与讨论')}
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            加入讨论
          </button>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
        >
          <i className={`text-lg ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {hint && (
        <div className="border-t border-background-200 bg-secondary-50">
          <div className="mx-auto flex w-full max-w-[1200px] items-center gap-2 px-4 py-2 text-xs text-secondary-900 md:px-6">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-information-line text-sm" />
            </span>
            <span>{hint}</span>
            <button
              type="button"
              onClick={() => setHint('')}
              className="ml-auto cursor-pointer text-secondary-700 hover:text-secondary-900"
            >
              关闭
            </button>
          </div>
        </div>
      )}

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="mx-auto flex w-full max-w-[1200px] flex-col px-4 py-2">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer whitespace-nowrap border-b border-background-100 py-3 text-sm text-foreground-800"
              >
                {item.label}
              </a>
            ))}
            <button
              type="button"
              onClick={() => {
                setMenuOpen(false);
                setHint('加入入口为演示效果，正式版本会引导你完成注册后参与讨论');
              }}
              className="mt-3 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              加入讨论
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}